import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'project',
		title: 'global.project',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'site',
		title: 'global.site',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'startDate',
		title: 'global.startDate',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'ratio',
		title: 'global.conversionFactor',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'isUsed',
		title: 'global.used',
		sortable: true,
		type: 'conversionFactorUsedStatus',
		defaultVisible: true,
	},

	{
		accessor: 'organization',
		title: 'global.organization',
		type: 'shortText',
		defaultVisible: false,
		sortable: true,
	},
	{
		accessor: 'entity',
		title: 'global.producer',
		sortable: false,
		type: 'shortText',
		defaultVisible: true,
	},
	{
		accessor: 'createdAt',
		title: 'global.createdAt',
		type: 'shortText',
		defaultVisible: false,
		sortable: true,
	},
	{
		type: 'conversionFactorsActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		width: 50,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
